import { cn } from '@/lib/utils';

/**
 * Branded skeleton — uses a left-to-right shimmer over the surface-2 token.
 * Looks intentional, not generic. Pair with bordered containers for polish.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-vt-sm bg-vt-surface-2',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-[vt-shimmer_1.4s_ease-in-out_infinite]',
        'before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent',
        'dark:before:via-white/5',
        className
      )}
      aria-hidden="true"
      {...props}
    />
  );
}
